import { ChemicalComponent } from "@/services/chemical-component"
import { FunctionOutlined } from "@ant-design/icons"
import { Button, Col, Form, InputNumber, Row, Space } from "antd"
import { useEffect } from "react"
import styles from './styles.module.less';


export const HeatCapacityForm = (props: {
  component?: ChemicalComponent.Modal,
  onSave: (val) => void
  onCancel?: Function
}) => {
  const {onSave, onCancel, component}= props
  const [form] = Form.useForm()

  useEffect(() => {
    if (component) {
      form.setFieldsValue(component.hsIdGasPoly5)
    }
  }, [component, form])
  
  return <Form
    form={form}
    onFinish={(values) => {
      onSave({hsIdGasPoly5: values})
    }}
    className="mt-4"
  >
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='a_h'
          label='a_h'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='a_s'
          label='a_s'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='b'
          label='b'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='c'
          label='c'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='d'
          label='d'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
          name='e'
          label='e'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='f'
          label='f'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
          name='tmin'
          label='Tmin(K)'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='tmax'
          label='Tmax(K)'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      </Col>
    </Row>

    <div className={styles.tip}>
      <div><span style={{fontSize: 18, fontWeight: 'bold'}}><FunctionOutlined /></span>Ideal gas enthalpy is calculated with the formula:<span style={{fontWeight: 'bold'}}>h=a_h+b.T+c.T^2+d.T^3+e.T^4+f.T^5</span></div>
      <div><span style={{fontSize: 18, fontWeight: 'bold'}}><FunctionOutlined /></span>Ideal gas entropy is calculated with the formula:<span style={{fontWeight: 'bold'}}>s=a_s+b.ln(T/TRef)+2.c.T+3/2.d.T^2+4/3.e.T^3+5/4.f.T^4</span></div>
    </div>

    <Row justify={'end'} className="mt-2">
      <Space>
        <Button htmlType="button" onClick={() => onCancel?.()}>Cancel</Button>
        <Button type="primary" htmlType="submit">Save</Button>
      </Space>
    </Row>
    
  </Form>
}